import React, { Component } from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../../../../src/lib/component-base';
import Ad from '../../../../../../shared/components/Ad/Ad';
import { FlightTracker as FlightTrackerAds } from '../../../../../FlightTracker/components/ads';
import FlightMapContainer from './children/FlightMapContainer';
import onResize from '../../../../../../src/lib/on-resize';

@onResize()
@componentBase('FlightPositionalInformationSection')
export default class FlightPositionalInformationSection extends Component {
  static propTypes = {
    flight: PropTypes.object.isRequired,
    showAds: PropTypes.bool,
    params: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);

    this.muiDefaultProps = {
      headerStyle: {
        margin: '15px 15px 15px 20px',
        fontWeight: 700,
      },
    };
  }

  componentDidMount() {
    this.initResizeListener();
    this.forceUpdate();
  }

  componentWillUnmount() {
    this.removeResizeListener();
  }

  handleResize = () => this.forceUpdate();

  render() {
    const subscriptionActive = this.context &&
                               this.context.currentUser &&
                               this.context.currentUser.subscriptionActive;
    if (this.props.flight && this.props.flight.flightId) {
      let adBlock = null;
      let mobileAdBlock = null;
      if (this.props.showAds) {
        const adComponents = [
          <Ad
            key={FlightTrackerAds.top.id}
            {...FlightTrackerAds.top}
            subscriptionActive={subscriptionActive}
          />,
        ];

        if (this.mediaBreakpoint && this.mediaBreakpoint.value > 769) {
          adComponents.push(<Ad
            key={FlightTrackerAds.bottom.id}
            {...FlightTrackerAds.bottom}
            subscriptionActive={subscriptionActive}
          />);
        }

        adBlock = (
          <div className={`FlightPositionalInformationAdsContainer ${subscriptionActive ? 'subscription-active' : 'col-xs-12 col-sm-12 col-md-4 col-lg-3'}`}>
            <div className='FlightPositionalInformationAds'>
              {adComponents}
            </div>
          </div>
        );
      } else if (!subscriptionActive) {
        const adComponents = [
          <Ad
            key={FlightTrackerAds.bottomMobile.id}
            {...FlightTrackerAds.bottomMobile}
            subscriptionActive={subscriptionActive}
          />,
        ];

        if (this.mediaBreakpoint && this.mediaBreakpoint.value > 769) {
          adComponents.push(<Ad
            key={FlightTrackerAds.top.id}
            {...FlightTrackerAds.top}
            subscriptionActive={subscriptionActive}
          />);
        }

        mobileAdBlock = (
          <div className={`FlightPositionalInformationAdsContainerMobile ${subscriptionActive ? 'subscription-active' : 'col-xs-12 col-sm-12 col-md-4 col-lg-3'}`}>
            <div className='FlightPositionalInformationAdsMobile'>
              {adComponents}
            </div>
          </div>
        );
      }

      return (
        <div>
          <h4 style={this.muiDefaultProps.headerStyle}>Tracking Map</h4>
          <div className='row'>
            <div className={subscriptionActive ? 'col-xs-12 col-sm-12 col-md-12 col-lg-12' : 'col-xs-12 col-sm-12 col-md-8 col-lg-9'}>
              <div className='FlightMap'>
                <FlightMapContainer {...this.props} />
              </div>
            </div>
            {mobileAdBlock}
            {adBlock}
          </div>
        </div>
      );
    }
    return <div />;
  }
}



// WEBPACK FOOTER //
// ./modules/SingleFlight/children/FlightTracker/children/FlightPositionalInformationSection/FlightPositionalInformationSection.js